// extracted by mini-css-extract-plugin
export default {"copy-link":"copy-link--mp-n6DPL","copyLink":"copy-link--mp-n6DPL"};